import { createAction } from 'typesafe-actions';
import { DmWalCurveSecurityState } from '../types/state/DmWalCurveState';

const show = createAction("dm-wal-curve/SHOW",
    resolve => (position: DmWalCurveSecurityState) => resolve({ position }));
const hide = createAction("dm-wal-curve/HIDE");

export const dmWalCurveActions = {
    show,
    hide
}
